import { Button, Space, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

import { IAward } from "../../../../../../../interfaces";

interface IProps {
    award: IAward;
    onClickEditAward: (award: IAward) => void;
    onClickDeleteAward: () => void;
    disableDelete?: boolean;
}

export default function AwardsTableRowActions({
    award,
    onClickEditAward,
    onClickDeleteAward,
    disableDelete = false,
}: IProps) {
    return (
        <Space size={6}>
            <Tooltip title="Editar dados do prêmio">
                <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => onClickEditAward(award)}
                    style={{
                        borderRadius: 6,
                    }}
                />
            </Tooltip>
            <Tooltip title={disableDelete ? "Salve a ordenação antes de excluir" : "Excluir prêmio"}>
                <Button
                    size="small"
                    type="primary"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={onClickDeleteAward}
                    disabled={disableDelete}
                    style={{
                        borderRadius: 6,
                    }}
                />
            </Tooltip>
        </Space>
    );
}